import { Box, Typography, TextField } from "@mui/material";
import React from "react";

export const Step1 = (props) => {
  const { register, errors } = props;
  return (
    <Box sx={{ mt: 3 }}>
      <Typography variant="h6">
        Datos del propietario o representante
      </Typography>
      <TextField
        {...register("nombre", {
          required: "El nombre es obligatorio",
        })}
        label="Nombre"
        fullWidth
        required
        sx={{ mb: 2, mt: 2 }}
        error={!!errors.nombre}
        helperText={errors.nombre?.message}
      />
      <TextField
        {...register("apellidos", {
          required: "Los apellidos son obligatorios",
        })}
        label="Apellidos"
        fullWidth
        required
        sx={{ mb: 2 }}
        error={!!errors.apellidos}
        helperText={errors.apellidos?.message}
      />
      <TextField
        {...register("nif", { required: "El NIF/CIF es obligatorio" })}
        label="NIF/CIF"
        fullWidth
        required
        sx={{ mb: 2 }}
        error={!!errors.nif}
        helperText={errors.nif?.message}
      />
      <TextField
        {...register("telefono")}
        label="Teléfono de contacto"
        fullWidth
        sx={{ mb: 2 }}
        inputProps={{
          maxLength: 9,
          inputMode: "numeric",
          pattern: "[0-9]*",
        }}
        error={!!errors.telefono}
        helperText={errors.telefono?.message}
      />
      <TextField
        {...register("correo", {
          required: "El correo electrónico es obligatorio",
          pattern: {
            value: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
            message: "Formato de correo no válido",
          },
        })}
        label="Correo electrónico"
        type="email"
        fullWidth
        required
        sx={{ mb: 2 }}
        error={!!errors.correo}
        helperText={errors.correo?.message}
      />
    </Box>
  );
};

export default Step1;
